lmApp
  .service('SubscriberService', ['$rootScope', '$q', '$http',
    function ($rootScope, $q, $http) {

      var service = {};

      service.GetSubscribers = function (id) {
        var deferred = $q.defer();
        var url = 'collection/principal.subscriber/query';

        if (id) url += '/dimension/id/eq/' + id;

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetSubscriberPurchases = function (subscriber, offset, limit) {
        var deferred = $q.defer();
        var url = 'collection/purchase/query/dimension/subscriber_id/eq/' + subscriber.id
          + '/enum/' + offset + ',' + limit + '?t=' + Date.now();

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection.filter(function (o) {

              return o.offer.type === 'transactional';
            }));
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetSubscriberSubscriptions = function (subscriber, offset, limit) {
        var deferred = $q.defer();
        var url = 'collection/purchase/query/dimension/subscriber_id/eq/' + subscriber.id
          + '/enum/' + offset + ',' + limit + '?t=' + Date.now();

        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response.collection.filter(function (o) {

              return o.offer.type === 'subscription';
            }));
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.ResetPassword = function (subscriber) {
        var deferred = $q.defer();
        var url = 'cloud/operator/subscriber/password/reset';

        var data = {
          email: subscriber.id
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.ResetRCPassword = function (subscriber) {
        var deferred = $q.defer();

        var request = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          }
        };

        request.url = '/realchoice:80/auth/1/subscriber/password/generate/random';
        request.data = {
          subscriber_ext_id: subscriber.extid
        };

        request.headers['X-Auth-Token'] = $rootScope.globals.currentUser.token;

        request.method = 'POST';

        $http(request)
          .then(function (response) {
            var answer = response.data;
            var status = response.status;
            var headers = response.headers;
            var config = response.config;

            if (answer.result) {
              deferred.resolve(answer);
            } else {
              answer.data = request.data;
              answer.url = request.url;
              deferred.reject(answer.error);
            }
          }, function (response) {
            var reason = response.data;
            var status = response.status;
            var headers = response.headers;
            var config = response.config;

            reason.url = request.url;
            reason.data = request.data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetSubscriberReport = function () {
        var deferred = $q.defer();
        var request = {
          headers: {
            'X-Auth-Token':  $rootScope.globals.currentUser.token
          }
        };
        request.url = '/discovery:80/sdp/v2/subscriber-report';
        request.method = 'GET';
        request.responseType = 'arraybuffer';
        $http(request)
          .then(function (response) {
            var headers = response.headers;
            var type = headers('Content-Type');
            var blob = new Blob([response.data], { type : type});
            var objectUrl = (window.URL || window.webkitURL).createObjectURL(blob);
            var link = angular.element('<a/>');
            link.attr({
              href : objectUrl,
              download : "subscriber-report.xlsx"
            })[0].click();
          }, function (response) {
            var reason = {};
            reason.url = request.url;
            reason.data = "GET";
            deferred.reject(reason);
          });
        return deferred.promise;
      };

      service.GetNARSubscriberReport = function () {
        var deferred = $q.defer();
        var request = {
          headers: {
            'X-Auth-Token':  $rootScope.globals.currentUser.token
          }
        };
        request.url = '/discovery:80/nar/v1/subscriber-report';
        request.method = 'GET';
        request.responseType = 'arraybuffer';
        $http(request)
          .then(function (response) {
            var headers = response.headers;
            var type = headers('Content-Type');
            var blob = new Blob([response.data], { type : type});
            var objectUrl = (window.URL || window.webkitURL).createObjectURL(blob);
            var link = angular.element('<a/>');
            link.attr({
              href : objectUrl,
              download : "subscriber-report.xlsx"
            })[0].click();
          }, function (response) {
            var reason = {};
            reason.url = request.url;
            reason.data = "GET";
            deferred.reject(reason);
          });
        return deferred.promise;
      };

      service.GetCSVSubscriberReport = function () {
        var deferred = $q.defer();
        var request = {
          headers: {
            'X-Auth-Token':  $rootScope.globals.currentUser.token,
            'Accept': 'text/csv'
          }
        };
        request.url = '/discovery:80/sdp/v2/subscriber-report';
        request.method = 'GET';
        $http(request)
          .then(function (response) {
            var link = angular.element('<a/>');
            link.attr({
              href: 'data:attachment/csv,' + encodeURI(response.data),
              target: '_blank',
              download : "subscriber-report.csv"
            })[0].click();
          }, function (response) {
            var reason = {};
            reason.url = request.url;
            reason.data = "GET";
            deferred.reject(reason);
          });
        return deferred.promise;
      };

      service.ResetPin = function (subscriber) {
        var deferred = $q.defer();
        var url = 'parental_control/pin/reset';

        var data = {
          subscriber_id: subscriber.id,
          type: 'random'
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetSubscriberInfo = function (subscriber) {
        var deferred = $q.defer();
        var url = 'cloud/operator/subscribers';

        var data = {
          ext_id: subscriber.extid
        };

        lh.common.request.get(url, data)
          .then(function (response) {
            deferred.resolve(response.subscribers);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetSubscribersByGroup = function (ids) {
        var deferred = $q.defer();
        var url = 'collection/principal.subscriber/query/dimension/group_id/in/' + ids.join(',') + '?t=' + Date.now();

        lh.common.request(url)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetSubscriberMsg = function (subscriber, limit) {
        var deferred = $q.defer();
        var url = 'notification/inapp/list'

        var data = {
          subscriber_id: subscriber.id,
          limit: limit
        };

        lh.common.request.get(url, data)
          .then(function (response) {
            deferred.resolve(response.notifications);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.SendSubscriberMsg = function (subscriber, msg) {
        var deferred = $q.defer();
        var url = 'notification/inapp/create/mail/raw';

        var data = {
          subscriber_id: subscriber.id,
          title: msg.title,
          body: msg.body
        };

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response.collection);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      return service;
    }]);

lmApp.factory('SubscriberDevices', ['$resource', function($resource) {
  return $resource('/discovery:80/sdp/v2/devices?subscriber.id[eq]=:id&$expand=*',
    {id: '@id'},
    {
      get: {
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
        }
      }
    }
    );
}]);
